<template>
  <div class="slider__card weighnow-slider-item">
    <img src="~@/assets/images/slider-item-imgs/img047.png" class="opt-in-cover-image" alt="img047.png">
    <div class="text-container">
      <text-string :label-id="labelText"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: "opt-in-cover",
    props: {
      cardDetails: {type: Object},
    },
    computed: {
      labelText() {
        return this.cardDetails.opt_in ? 'txt1439' : 'txt1444';
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import "~@/assets/styles/applications.scss";

  .weighnow-slider-item > .opt-in-cover-image {
    width: 100px;
    height: 100px;
    border: 1px solid #E1E1E1;
  }
</style>
